<template>
    <div id="certificate">
        <div class="title">功能设置 > <span class="title-detail" @click="$router.go(-1)"> 预约日历</span></div>
        <div class="mains" v-show="!operate">
            <div class="operation">
                <el-button type="primary" style="margin-left: 60px;" @click="addCalendar">新增日历</el-button>
            </div>
            <div style="height: 10px; background: #f0f0f0;"></div>
            <div class="table">
                <el-table ref="dragTable" v-loading="loading" :data="tableData" row-key="id" fit highlight-current-row style="width: 100%">
                    <el-table-column align="center" label="日历名称">
                        <template slot-scope="{row}">
                            <span>{{ row.name }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="同步国家法定节假日">
                        <template slot-scope="{row}">
                            <span>{{ row.sync }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center">
                        <template slot-scope="{row}">
                            <template v-if="row.is_default">
                                <span>设为默认</span>
                            </template>
                            <template v-else>
                                <el-link type="primary" @click="setDefault(row)">设为默认</el-link>
                            </template>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="操作">
                        <template slot-scope="{row}">
                            <el-link type="primary" @click="updateCalendar(row)">编辑</el-link>
                            <el-link type="danger" style="margin-left: 12px;" @click="delCalendar(row.id)">删除</el-link>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="mains2" v-show="operate">
            <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" v-loading="formLoading">
                <el-form-item label="日历名称：" prop="name">
                    <el-input v-model="form.name" style="width: 500px;"></el-input>
                    <span style="margin-left: 20px;">设为默认</span> 
                    <el-switch style="margin-left: 12px;" v-model="form.is_default"></el-switch>
                </el-form-item>
                <el-form-item label="日历类型：">
                    <el-radio value="1" label="1">周</el-radio>
                    <el-checkbox-group v-model="form.week_list">
                        <el-checkbox label="周一" name="type"></el-checkbox>
                        <el-checkbox label="周二" name="type"></el-checkbox>
                        <el-checkbox label="周三" name="type"></el-checkbox>
                        <el-checkbox label="周四" name="type"></el-checkbox>
                        <el-checkbox label="周五" name="type"></el-checkbox>
                        <el-checkbox label="周六" name="type"></el-checkbox>
                        <el-checkbox label="周日" name="type"></el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="预约时间段：" prop="times" class="subscribe-time">
                    <el-form-item v-for="(item, index) in subscribe" :key="index" :style="{'margin-top': index == 0 ? '0px' : '20px'}">
                        <el-time-picker
                            is-range
                            v-model="item.time"
                            style="width: 400px;"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            placeholder="选择时间范围">
                        </el-time-picker>
                        <el-input-number v-model="item.quota" placeholder="可预约人数" :controls="false" style="width: 200px; margin-left: 24px;"></el-input-number>
                        <template v-if=" index == 0">
                            <div class="circle-plus-outline">
                                <i class="el-icon-circle-plus-outline icon_cursor" @click="onAdd"></i>
                            </div>
                        </template>
                        <template v-else>
                            <div class="remove-outline">
                                <i class="el-icon-remove-outline icon_cursor2" @click="onRemove(item.id, index)"></i>
                            </div>
                        </template>
                    </el-form-item>
                </el-form-item>
                <el-form-item label="法定节假日：">
                    <el-switch v-model="form.sync"></el-switch>
                </el-form-item>
            </el-form>
            <div class="bottom-button">
                <el-divider></el-divider>
                <div style="align-self: flex-end;">
                    <el-button @click="cancel">取 消</el-button>
                    <el-button type="primary" @click="sureSave('ruleForm')">确 定</el-button>
                </div>
            </div>
        </div>
        <el-dialog
            title="提示"
            :visible.sync="delDialog"
            width="40%">
            <p>删除该日历，是否继续？</p>
            <span slot="footer" class="dialog-footer">
                <el-button @click="delDialog = false" size="small">取 消</el-button>
                <el-button type="primary" @click="sureDelete" size="small">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getDateList, setDate, deleteDate } from '@/api/baby/calendar.js'
export default {
    data () {
        return {
            loading: false,
            formLoading: false,
            data: [],
            delDialog: false,
            operate: false,
            form: {
                id: 0,
                name: '',   // 要创建的日历名称，限制2~20个字符
                is_default: 0,  // 是否是默认日历【默认日历永远在第一位】
                week_list: [],  // 周列表，从左到右分别为周日、周一......周六
                type: 1,    // 日历类型 1-周列表
                times: [    // 所选时间段列表
                    { 
                        id: 0,
                        start_time: '08:00',
                        end_time: '18:00',
                        quota: 0,
                        is_delete: 0
                    }
                ],
                sync: 0,    // 是否同步国家法定节假日 0-否 1-是 PS：同步法定节假日的话周列表将失效
                ticket_type: 0, // 预约类型 0-平日票 1-假日票（sync=1时使用此值确定可预约范围）
            },
            rules: {
                name: [
                    { required: true, message: '请输入日历名称', trigger: 'blur' }
                ]
            },
            subscribe: [
                {
                    time: [new Date(2021, 1, 1, 0, 0, 0), new Date(2021, 1, 1, 23, 59, 59)],
                    quota: 0,
                    is_delete: 0,
                    id: 0
                }
            ],
            week_list: [
                { name: '周一', value: 0 },
                { name: '周二', value: 0 },
                { name: '周三', value: 0 },
                { name: '周四', value: 0 },
                { name: '周五', value: 0 },
                { name: '周六', value: 0 },
                { name: '周日', value: 0 },
            ]
        }
    },
    computed: {
        tableData () {
            return this.data.map(item => {
                return {...item, sync: item.sync == 1 ? '是': '否'}
            });
        }
    },
    watch: {},
    methods: {
        // 将所选日历设置为默认日历，默认日历在列表首位 需要发送请求去改变
        setDefault (row) {
            let data = {...row, sync: row.sync == '是' ? 1 : 0, is_default: 1, times: JSON.stringify(row.times)};
            setDate(data)
                .then(res => {
                    if (res.data.code == 0) {
                        this.getList();
                    } else {
                        this.$message.error(res.data.msg);
                    }
                })
                .catch(err => {
                    this.$message.error(err.msg);
                })
        },
        // 取消创建
        cancel () {
            this.operate = false;
        },
        // 添加一项日历
        onAdd () {
            this.subscribe.push({time: [new Date(2021, 1, 1, 0, 0, 0), new Date(2021, 1, 1, 23, 59, 59)], quota: '', is_delete: 0, id: 0})
        },
        // 删除一项日历，如果是新添加的只对列表进行操作，如果是编辑时进行删除，则需要请求数据进行删除改变is_delete状态值
        onRemove (id, index) {
            if (id == 0) {
                this.subscribe.splice(index, 1);
                return
            }
            this.formLoading = true;
            let times = this.subscribe.map(item => {
                let start = item.time[0],
                    end = item.time[1],
                    start_time = this.buling(start.getHours()) + ':' + this.buling(start.getMinutes()),
                    end_time = this.buling(end.getHours()) + ':' + this.buling(end.getMinutes());
                return { 
                    id: item.id, 
                    is_delete: id == item.id ? 1 : item.is_delete, 
                    quota: item.quota, 
                    start_time, 
                    end_time 
                }
            })
            let week_list = [
                { name: '周一', value: 0 },
                { name: '周二', value: 0 },
                { name: '周三', value: 0 },
                { name: '周四', value: 0 },
                { name: '周五', value: 0 },
                { name: '周六', value: 0 },
                { name: '周日', value: 0 }
            ];
            this.form.week_list.forEach(week => {
                let index = week_list.findIndex(item => {
                    return week == item.name
                })
                if (index > -1) {
                    week_list[index].value = 1;
                }
            })
            let data = {
                ...this.form,
                is_default: this.form.is_default ? 1 : 0,
                sync: this.form.sync ? 1 : 0,
                week_list: week_list.map(week => week.value).join(''),
                times: JSON.stringify(times)
            }
            setDate(data)
                .then(res => {
                    if (res.data.code == 0) {
                        this.subscribe.splice(index, 1);
                    } else {
                        this.$message.error(res.data.msg);
                    }
                })
                .catch(err =>{
                    this.$message.error(err.msg);
                })
                .finally( _ => {
                    this.formLoading = false;
                    this.getList();
                })
        },
        // 保存
        sureSave () {
            let week_list = [
                { name: '周一', value: 0 },
                { name: '周二', value: 0 },
                { name: '周三', value: 0 },
                { name: '周四', value: 0 },
                { name: '周五', value: 0 },
                { name: '周六', value: 0 },
                { name: '周日', value: 0 }
            ];
            this.form.week_list.forEach(week => {
                let index = week_list.findIndex(item => {
                    return week == item.name
                })
                if (index > -1) {
                    week_list[index].value = 1;
                }
            })
            
            let times = this.subscribe.map(item => {
                let start = item.time[0],
                    end = item.time[1],
                    start_time = this.buling(start.getHours()) + ':' + this.buling(start.getMinutes()),
                    end_time = this.buling(end.getHours()) + ':' + this.buling(end.getMinutes());
                return { 
                    id: item.id, 
                    is_delete: item.is_delete, 
                    quota: item.quota, 
                    start_time, 
                    end_time 
                }
            })
            let data = {
                ...this.form,
                is_default: this.form.is_default ? 1 : 0,
                sync: this.form.sync ? 1 : 0,
                week_list: week_list.map(week => week.value).join(''),
                times: JSON.stringify(times)
            };
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    setDate(data)
                        .then(res => {
                            if (res.data.code == 0) {
                                this.operate = false;
                                    let message = '';
                                if (data.id == 0) {
                                    message = '添加日历成功!';
                                } else {
                                    message = '编辑日历成功!';
                                }
                                this.$message.success(message)
                                this.getList();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        })
                        .catch(err => {
                            this.$message.error(err.msg);
                        })
                } else {
                    return 
                }
            })
        },
        // 添加日历
        addCalendar () {
            this.form = {id: 0, name: '', is_default: 0, week_list: [], type: 1, times: [], sync: 0, ticket_type: 0};
            this.subscribe = [
                {
                    time: [new Date(2021, 1, 1, 0, 0, 0), new Date(2021, 1, 1, 23, 59, 59)],
                    quota: 0,
                    is_delete: 0,
                    id: 0
                }
            ];
            this.operate = true;
        },
        // 编辑日历
        updateCalendar (row) {
            let week_list = [];
            this.week_list.forEach((item, index) => {
                if (row.week_list[index] == 1) {
                    week_list.push(item.name)
                }
            })
            this.form = {
                ...row, 
                week_list, 
                is_default: row.is_default == 1 ? true : false,
                sync: row.sync == '是' ? true : false
            };
            this.subscribe = row.times.map(item => {
                let start_time = item.start_time.split(':'),
                    end_time = item.end_time.split(':');
                return {
                    id: item.id,
                    is_delete: item.is_delete, 
                    quota: item.quota, 
                    time: [
                        new Date(2021, 1, 1, start_time[0], start_time[1], start_time[2]), 
                        new Date(2021, 1, 1, end_time[0], end_time[1], end_time[2])
                    ]
                }
            });
            this.operate = true; 
        },
        // 删除日历
        delCalendar (id) {
            this.form.id = id;
            this.delDialog = true;
        },
        // 确认删除
        sureDelete () {
            deleteDate({id: this.form.id})
                .then(res => {
                    if (res.data.code == 0) {
                        this.$message.success('删除成功！');
                        this.getList();
                    } else {
                        this.$message.error(res.data.msg);
                    }
                })
                .catch(err => {
                    this.$message.error(err.msg);
                })
                .finally(_ => {
                    this.delDialog = false;
                })
        },
        getList () {
            this.loading = true;
            getDateList()
                .then(res => {
                    if (res.data.code == 0) {
                        this.data = res.data.data.data;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                })
                .catch(err => {
                    this.$message.error(err.msg);
                })
                .finally( _ => {
                    this.loading = false;
                })
        },
        buling (value) {
            return value > 10 ? value : '0' + value
        },
    },
    created() {
        this.getList()
    }
}
</script>

<style lang="scss" scoped>
    #certificate {
        width: 100%;
        min-height: 780px;
        background: #f0f0f0;
        min-width: 1200px;
        .title {
            box-shadow: 0px 0px 8px 0px rgba(100, 100,100, .17);
            // width: 100%;
            background: #fff;
            padding: 15px 32px;
            display: flex;
            align-items: center;
            font-size: 18px;
            color: #000;
            .title-detail {
                margin-left: 5px;
                color: rgb(109, 109, 109);
                cursor: pointer;
            }
            p {
                font-size: 16px;
                color: #333;
                margin-left: 32px;

                span {
                    color: #e72f0d;
                    padding: 0 5px;
                }

                &:first-child {
                    font-size: 18px;
                    color: #333;
                    margin-left: 0;
                }

                &:nth-child(2) {
                    span {
                        color: #2448ff;
                    }
                }
            }
            .title-detail {
                cursor: pointer;
            }
        }
        .mains {
            margin: 24px;
            background-color: #fff;
            display: flex;
            flex-direction: column;
            min-height: 600px;
            .operation {
                width: 100%;
                height: 70px;
                display: flex;
                align-items: center;
                padding-top: 10px;
                padding-bottom: 10px;
            }
            .table {
                margin-top: 24px;
            }
        }
    }

    .mains2 {
        margin: 24px;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: 50px 24px 24px 48px;
        min-height: 600px;
        justify-content: space-between;
    }

    .circle-plus-outline, .remove-outline {
        position: absolute;
        right: -40px;
        top: 50%;
        transform: translateY(-50%);
        height: 30px;
    }

    .icon_cursor {
        font-size: 30px; 
        color: #409EFF;
        &:hover {
            color: #909399;
        }
    }
    .icon_cursor2 {
        font-size: 30px; 
        color: #F56C6C;
        &:hover {
            color: #909399;
        }
    }
    
    .subscribe-time {
        position: relative;
        display: inline-block;
        .el-form-item :not :first-child {
            margin-top: 20px;
        }
    }
    
    .bottom-button {
        display: flex;
        flex-direction: column;
    }

    ::v-deep .el-dialog__header {
        border-bottom: 1px solid #F1F1F1;
        font-weight: bold;
    }
    
    ::v-deep .el-dialog {
        border-radius: 10px;
        min-width: 580px;
    }

    ::v-deep .el-dialog__footer {
        border-top: 1px solid #F1F1F1;
        padding: 10px 20px 10px;
    }

    ::v-deep .el-dialog__body {
        padding: 60px 80px;
    }

</style>
<style>
    .sortable-ghost{
        opacity: .8;
        color: #fff!important;
        background: #409EFF!important;
    }
</style>